import {BASE_URL, PATH_ASSETS} from "./Constant";

/**
 * @param val
 * @returns {boolean}
 */
export function empty(val) {
    return (typeof val === 'undefined' || val === '' || val === 0 || val === '0' || val === null
        || val === false || (typeof val === 'object' && !Object.keys(val).length)
    );
}

/**
 * @param fileName
 * @param folder
 * @returns {string}
 */
export function imgPath(fileName, folder = 'img') {
    return BASE_URL + ([PATH_ASSETS, folder, fileName].join('/'));
}

/**
 * @param obj
 * @param prop
 * @param defaultVal
 * @returns {*}
 */
export function getValue(obj, prop, defaultVal = null) {
    return empty(obj[prop]) ? defaultVal : obj[prop];
}

/**
 * @param collection
 * @param key
 * @param value
 * @returns {number}
 */
export function findIndexByKey (collection, key, value) {
    return empty(collection) ? -1 : collection.findIndex(el => {
        return el[key] === value
    });
}

/**
 * @param collection
 * @param id
 * @returns {number}
 */
export function findById(collection, id) {
    return findIndexByKey(collection, 'id', id);
}

/**
 * // example numberFormat(1000, 0, '.', ' ')
 * @param number
 * @param decimals
 * @param dec_point
 * @param thousands_sep
 * @returns {string}
 */
export function numberFormat(number, decimals = 2, dec_point = ',', thousands_sep = ' ') {
    let i, j, kw, kd, km, minus = "";
    number = strToFloat(number);

    if (number < 0) {
        minus = "-";
        number = number * -1;
    }

    i = parseInt(number = (+number || 0).toFixed(decimals), 10) + "";

    if ((j = i.length) > 3) {
        j = j % 3;
    } else {
        j = 0;
    }

    km = (j ? i.substr(0, j) + thousands_sep : "");
    kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
    kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");

    return minus + km + kw + kd;
}

/**
 * @param value
 * @returns {*}
 */
export function strToFloat(value) {
    if(empty(value)) {
        return 0;
    }
    return typeof value === 'number' ? value :  parseFloat(value.replace('/\\s+/', ''));
}

